import { render } from "./Fleury.vue?vue&type=template&id=1c33c0c7&scoped=true"
import script from "./Fleury.vue?vue&type=script&lang=js"
export * from "./Fleury.vue?vue&type=script&lang=js"

import "./Fleury.vue?vue&type=style&index=0&id=1c33c0c7&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c33c0c7"]])

export default __exports__